<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Create Filler Article</h1>
        </div>
        <single
            style="max-width: 800px"
            :filler-article="filler_article"
            v-if="filler_article"
        />
    </vue-scroll>
</template>

<script>
import Single from "./Single";

export default {
    components: { Single },
    beforeRouteEnter(to, from, next) {
        axios
            .get(`/web-api/filler-article/${to.params.id}`)
            .then((response) => {
                next((vm) => vm.setData(response));
            });
    },
    component: {
        Single,
    },
    data() {
        return {
            filler_article: null,
        };
    },
    methods: {
        setData(response) {
            this.filler_article = response.data;
        },
    },
};
</script>

<style scoped></style>
